<!--  -->
<template>
<div class='container'>
    <img src="../../assets/image/finish_get.png" alt="">
    <div class="hint_one" v-show="type == 1">提交成功</div>
    <div class="hint_one" v-show="type == 0">注册成功</div>
    <div class="hint_two" v-show="type == 1">您的申请已提交系统审核我们会在1~3个工作日内给您反馈请耐心等待！</div>
    <div class="hint_two" v-show="type == 0">登录进行培训报名</div>
    <button class="know" @click="goIndex" v-show="type == 0">我知道了</button>
    <button class="goHome" @click="goIndex" v-show="type == 1">返回首页</button>
    <button class="lookClass" @click="goClass" v-show="type == 1">查看课程</button>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    type:0
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    goIndex(){
        this.$router.push({path:"/"})
    },
    goClass(){
        this.$router.push({path:"/"})
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    if(this.$route.params.from == 1){
        this.type = 1
    }
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    img{
        width: 88px;
        height: 88px;
        margin-top: 57px;
    }
    .hint_one{
        font-size: 21px;
        color: #333333;
        font-weight: 500;
        margin-top: 21px;
    }
    .hint_two{
        width: 45%;
        text-align: center;
        font-size: 14px;
        color: #666666;
        margin:24px auto 0;
    }
    .know{
        width: 139px;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #2F85ED;
        font-size: 17px;
        color: #2F85ED;
        margin-top: 82px;
    }
    .goHome{
        width: 35%;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        font-size: 17px;
        color: #333333;
        margin-top: 82px;
        float: left;
        margin-left: 10%;
    }
    .lookClass{
        width: 35%;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        font-size: 17px;
        color: #333333;
        margin-top: 82px;
        float: right;
        margin-right: 10%;
    }
}

</style>